// import React from 'react';
// import { Navigate, useRoutes } from 'react-router-dom';

// // Pages and Layouts
// import DashboardLayout from './Layouts/Dashboard';
// import StorylaneDemo from './Components/StorylaneDemo';
// import ScheduleDemoForm from './Components/ScheduleDemoForm';

// // Auth utility functions
// export const isAuthenticated = () => {
//     const user = localStorage.getItem('storylane_user');
//     return user !== null;
// };

// export const getUserData = () => {
//     const user = localStorage.getItem('storylane_user');
//     return user ? JSON.parse(user) : null;
// };

// export const setUserData = (userData) => {
//     localStorage.setItem('storylane_user', JSON.stringify(userData));
// };

// export const clearUserData = () => {
//     localStorage.removeItem('storylane_user');
// };

// // Protected Route Wrapper Component
// const ProtectedRoute = ({ children }) => {
//     return isAuthenticated() ? children : <Navigate to="/" replace />;
// };

// const Router = () => {
//     const routes = [
//         // Landing page - Storylane Demo (public but blurred until registration)
//         {
//             path: '/',
//             element: <StorylaneDemo />
//         },

//         // Dashboard with protected routes
//         {
//             path: '/dashboard',
//             element: (
//                 <ProtectedRoute>
//                     <DashboardLayout />
//                 </ProtectedRoute>
//             ),
//             children: [
//                 {
//                     path: 'demos',
//                     element: (
//                         <ProtectedRoute>
//                             <StorylaneDemo />
//                         </ProtectedRoute>
//                     )
//                 },
//                 {
//                     path: 'schedule',
//                     element: (
//                         <ProtectedRoute>
//                             <ScheduleDemoForm />
//                         </ProtectedRoute>
//                     )
//                 },
//                 {
//                     index: true,
//                     element: <Navigate to="/dashboard/demos" replace />
//                 }
//             ]
//         },

//         // Catch-all redirect
//         {
//             path: '*',
//             element: <Navigate to="/" replace />
//         }
//     ];

//     return useRoutes(routes);
// };

// export default Router;

// --------------------------------------------------

import React from "react";
import { Navigate, useRoutes } from "react-router-dom";

// Pages and Layouts
import DashboardLayout from "./Layouts/dashboard";
import StorylaneDemo from "./Components/StorylaneDemo";
import ScheduleDemoForm from "./Components/ScheduleDemoForm";
import UserRegistrationForm from "./Components/UserRegistrationForm";
import UserLoginForm from "./Components/UserLoginForm";
import Login from "./Components/Pages/Login";
import DemoRequestPage from "./Components/Pages/DemoRequestPage";
import DemoManagement from "./Components/Admin/DemoManagement";
import RequestManagement from "./Components/Admin/RequestManagement";
import UserManagement from "./Components/Admin/UserManagement";
import CredentialsPage from "./Components/Pages/CredentialsPage";

// Auth utility functions
export const isAuthenticated = () => {
  const user = localStorage.getItem("UserDetails");
  return user !== null;
};

export const getUserData = () => {
  const user = localStorage.getItem("UserDetails");
  return user ? JSON.parse(user) : null;
};

export const setUserData = (userData) => {
  localStorage.setItem("UserDetails", JSON.stringify(userData));
};

export const clearUserData = () => {
  localStorage.removeItem("UserDetails");
};

// Protected Route Wrapper Component
// requireAdmin=true restricts to users with role === 'admin'
const ProtectedRoute = ({ children, requireAdmin = false }) => {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  if (requireAdmin) {
    const data = getUserData();
    const role = data?.user?.role;
    if (role !== "admin") return <Navigate to="/dashboard/demos" replace />;
  }
  return children;
};

// Public Route Wrapper (redirects to dashboard/demos if already authenticated)
const PublicRoute = ({ children }) => {
  return isAuthenticated() ? (
    <Navigate to="/dashboard/demos" replace />
  ) : (
    children
  );
};

const Router = () => {
  const routes = [
    // Default route - redirect based on auth status
    {
      path: "/",
      element: isAuthenticated() ? (
        <Navigate to="/dashboard/demos" replace />
      ) : (
        <Navigate to="/login" replace />
      ),
    },

    // Registration page (public, redirects if authenticated)
    {
      path: "/register",
      element: (
        <PublicRoute>
          <UserRegistrationForm />
        </PublicRoute>
      ),
    },

    // Login page (public, redirects if authenticated)
    {
      path: "/login",
      element: (
        <PublicRoute>
          {/* <UserLoginForm /> */}
          <Login />
        </PublicRoute>
      ),
    },

    // Credentials from welcome email (public)
    {
      path: "/credentials",
      element: <CredentialsPage />,
    },

    // Post-registration demo selection (standalone — no dashboard chrome)
    {
      path: "/request-demos",
      element: (
        <ProtectedRoute>
          <DemoRequestPage />
        </ProtectedRoute>
      ),
    },

    // Dashboard with protected routes
    {
      path: "/dashboard",
      element: (
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      ),
      children: [
        {
          path: "demos",
          element: <StorylaneDemo />,
        },
        {
          path: "schedule",
          element: <ScheduleDemoForm />,
        },
        {
          index: true,
          element: <Navigate to="demos" replace />,
        },
        {
          path: "demo-management",
          element: (
            <ProtectedRoute requireAdmin>
              <DemoManagement />
            </ProtectedRoute>
          ),
        },
        {
          path: "requests",
          element: (
            <ProtectedRoute requireAdmin>
              <RequestManagement />
            </ProtectedRoute>
          ),
        },
        {
          path: "admin/users",
          element: (
            <ProtectedRoute requireAdmin>
              <UserManagement />
            </ProtectedRoute>
          ),
        },
      ],
    },

    // Catch-all redirect
    {
      path: "*",
      element: <Navigate to="/" replace />,
    },
  ];

  return useRoutes(routes);
};

export default Router;
